var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fields)?_c('div',{staticClass:"jump-to-section content-center"},[_c('div',{staticClass:"content-constraint"},[_c('base-button',{attrs:{"text":_vm.fields.buttonText},on:{"click":_vm.scrollToTarget}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }